<template>
  <div class="mds-stepper mds-stepper--wide mds-stepper--small">
    <div class="mds-stepper__active-step-summary">
      <span class="mds-stepper__active-step-label">
        {{ steps[current].name }}
      </span>
    </div>
    <ul class="mds-stepper__list">
      <li class="mds-stepper__list-item" v-for="(step, index) in steps" :key="index">
        <div
          class="mds-stepper__step"
          :class="{
            'mds-stepper__step--active': index == current,
            'mds-stepper__step--complete': index < current,
          }"
        >
          <a
            class="mds-stepper__step-indicator"
            tabindex="-1"
            :aria-current="current == index ? 'page' : ''"
            :href="`#${step.id}`"
            :title="step.name"
          >
            <svg
              class="mds-stepper__step-complete-icon"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="-0.044 0.062 9.211 8.841"
            >
              <path
                fill="none"
                stroke="#FFF"
                stroke-width="2"
                d="M.643 4.653L3.535 7.39 8.355.642"
              />
            </svg>
            <span class="mds-stepper__step-label">{{ step.name }}</span>
          </a>
          <span
            class="mds-stepper__step-progress-track mds-stepper__step-progress-track--large-step"
          ></span>
        </div>
        <a class="mds-stepper__list-item-label" tabindex="-1" :href="`#{step.name}`">
          {{ step.name }}
        </a>
      </li>
    </ul>
  </div>
</template>
<script>
export default {
  name: 'stepper',
  data() {
    return {};
  },
  props: {
    steps: {
      type: Array,
      required: true,
    },
    current: {
      type: Number,
      default: 0,
    },
  },
};
</script>
<style scoped lang="scss">
.mds-stepper {
  padding-bottom: $mds-space-4-x;

  .mds-stepper__list-item {
    -ms-flex-negative: 1;
    -ms-flex-positive: 1;
    -ms-flex-preferred-size: 0px;
  }
}
</style>
